var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.99975,68a36,36,0,1,0,36,36A36.04062,36.04062,0,0,0,127.99975,68Zm0,64a28,28,0,1,1,28-28A28.03146,28.03146,0,0,1,127.99975,132Zm0-112a84.0953,84.0953,0,0,0-84,84c0,30.418,14.1709,62.793,40.98145,93.625a250.12015,250.12015,0,0,0,40.72461,37.65186,4,4,0,0,0,4.58789,0A250.12015,250.12015,0,0,0,171.01831,197.625c26.81054-30.832,40.98144-63.207,40.98144-93.625A84.0953,84.0953,0,0,0,127.99975,20Zm37.10352,172.23437a254.03965,254.03965,0,0,1-37.10352,34.80079,254.04027,254.04027,0,0,1-37.10351-34.80079C73.1521,171.7959,51.99975,139.89648,51.99975,104a76,76,0,0,1,152,0C203.99975,139.89648,182.84741,171.7959,165.10327,192.23437Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlack);
export default __webpack_public_path__ + "static/media/location-black.45397e793642b5bca663882053cf15ec.svg";
export { ForwardRef as ReactComponent };